export default __webpack_public_path__ + "static/media/dstv.46798ebf.svg";